<style lang="scss" scoped src="./scss/exam.scss"></style>
<template>
  <div class="exam">
    <div class="exam-box">
      <Title name="我的考试"></Title>
      <div class="exam-list-search">
        <el-input
          size="small"
          placeholder="请输入考试名称"
          v-model="examName"
          prefix-icon="el-icon-search"
          @input="searchExamName"
        ></el-input>
        <el-select
          size="small"
          v-model="attendanceStatus"
          placeholder="请选择参加状态"
          @change="getStatus"
        >
          <el-option label="全部" :value="0"></el-option>
          <el-option label="已参加" :value="1"></el-option>
          <el-option label="未参加" :value="2"></el-option>
        </el-select>
      </div>
      <div class="sort-box">
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link"> 排序：{{ sortText }} </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="{ key: 2, value: '开始时间' }"
              >开始时间</el-dropdown-item
            >
            <el-dropdown-item :command="{ key: 1, value: '结束时间' }"
              >结束时间</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <el-tabs v-model="currentTab" @tab-click="handleTab">
        <el-tab-pane label="全部" name="0">
          <Table @handleFind="handleFind" :tableData="tableData"></Table>
        </el-tab-pane>
        <el-tab-pane label="训练营" name="1">
          <Table @handleFind="handleFind" :tableData="tableData"></Table>
        </el-tab-pane>
        <el-tab-pane label="系列课" name="2">
          <Table @handleFind="handleFind" :tableData="tableData"></Table>
        </el-tab-pane>
      </el-tabs>
      <div class="pagination">
        <el-pagination
          background
          :current-page.sync="page"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="totalPage"
          @current-change="changePagination"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Title from "../../components/title";
import Table from "../../components/exam/table";
import { getExamData, examDetail } from "../../server/exam";
export default {
  name: 'exam',
  data() {
    return {
      currentTab: "0",
      examName: "",
      attendanceStatus: null,
      value: "",
      page: 1,
      pageSize: 10,
      totalPage: 1,
      sortText: "结束时间",
      sort: 1,
      tableData: [],
    };
  },
  components: {
    Title,
    Table
  },
  mounted() {
    this.getExamList();
  },
  methods: {
    handleTab(e) {
      this.initData();
      this.getExamList();
    },
    searchExamName() {
      this.getExamList();
    },
    initData() {
      this.examName = "";
      this.page = 1;
      this.isFinish = 0;
    },
    handleFind(examId) {
      this.$router.push({
        path: 'examTransferPage',
        query: {
          examId: examId
        }
      })
    },

    /**
     * 排序事件
     */
    handleCommand(command) {
      this.sortText = command.value;
      this.sort = command.key;
      this.getExamList();
    },

    /**
     *  获取考试状态列表
     */
    getStatus() {
      this.page = 1;
      this.getExamList();
    },

    /**
     * 获取考试列表
     */
    getExamList() {
      getExamData({
        keyword: this.examName,
        isFinish: this.attendanceStatus,
        page: this.page,
        pageSize: 10,
        type: this.currentTab,
        sort: this.sort
      }).then(res => {
        const { code, msg, data } = res;
        this.totalPage = Number(data.totalNum);
        this.tableData = data.examList;
      });
    },
    changePagination(e) {
      this.page = e;
      this.getExamList();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/exam/exam.vue